import {IRoutableModule} from '../../router/routing.infra';
import {ConnectivityStandaloneView} from './connectivity-standalone.view';
import {ConnectivityStandaloneMobileView} from './connectivity-standalone-mobile.view';
import {connectivityStandaloneRouteLoader} from './connectivity-standalone.loader';

export default {
    loader: connectivityStandaloneRouteLoader,
    Component: ConnectivityStandaloneView,
    MobileComponent: ConnectivityStandaloneMobileView,
    storeAs: 'connectivityStandaloneStore'
} as IRoutableModule;
